import {
  DEFAULT_PAGE_SIZE,
  readStoredListPageSize,
  writeStoredListPageSize,
} from '../../shared/table/pagination.ts';

/** Default page size for Risks / RCM server-paged tables. */
export const RISKS_PAGINATION_PAGE_SIZE = DEFAULT_PAGE_SIZE;

/** @deprecated Use readStoredListPageSize — kept for Risks imports. */
export const readStoredRisksPageSize = readStoredListPageSize;

/** @deprecated Use writeStoredListPageSize — kept for Risks imports. */
export const writeStoredRisksPageSize = writeStoredListPageSize;
